import type { PropsWithChildren } from 'react';

export const IfRender = ({
  children,
  condition,
}: PropsWithChildren<IfRenderParams>) => (condition ? children : null);

export const MapRender = <T>({ items, render }: MapRenderParams<T>) =>
  items?.length ? items.map((item, index) => render(item, index)) : [];

interface IfRenderParams {
  condition: boolean;
}

interface MapRenderParams<T> {
  items: T[];
  render: (item: T, index: number) => JSX.Element;
}
